import { useQuery } from '@tanstack/react-query'
import { checkTripDetails } from 'tripPlanner/api/tripDetails'
import * as TripDetailsKeys from '../reactQueryKeys/tripDetails'

export const useTripDetailsCheckQuery = (text: string) => {
  return useQuery({
    queryKey: TripDetailsKeys.check(text),
    queryFn: ({ signal }) => checkTripDetails(text, signal),
    enabled: text.length > 0,
    keepPreviousData: true,
    staleTime: Infinity,
    retry: false,
  })
}
